module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/investment/investment-creation-grid/investment-creation-grid.component.css
// module id = ./src/app/investment/investment-creation-grid/investment-creation-grid.component.css
// module chunks = main